import { render, staticRenderFns } from "./createHospital.vue?vue&type=template&id=77830d80&scoped=true&"
import script from "./createHospital.vue?vue&type=script&lang=js&"
export * from "./createHospital.vue?vue&type=script&lang=js&"
import style0 from "./createHospital.vue?vue&type=style&index=0&id=77830d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77830d80",
  null
  
)

export default component.exports